import constate from 'constate';
import type React from 'react';
import { useEffect, useState } from 'react';
import type { TabId } from './types';

export interface TabsContext {
  defaultTabId: TabId;
  children?: React.ReactNode;
  onTabChange?: (tabId: TabId) => void;
}

const useTabsContext = ({ defaultTabId, onTabChange }: TabsContext) => {
  const [selectedTabId, setSelectedTabId] = useState<TabId>(defaultTabId);

  useEffect(() => {
    setSelectedTabId(defaultTabId);
  }, [defaultTabId]);

  const changeTab = (tid: TabId) => {
    setSelectedTabId(tid);
    onTabChange?.(tid);
    return;
  };

  return { selectedTabId, changeTab };
};

export const [TabsProvider, useTabs] = constate(useTabsContext);
